import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props { children: ReactNode }
interface State { error: string | null }

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { error: error?.message ?? String(error) };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[GameFix] render crash:', error.message, info.componentStack?.slice(0, 400));
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          minHeight: '100vh', background: '#0D0D0D', color: '#E0E0E0',
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', padding: '2rem', fontFamily: 'sans-serif',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>⚠️</div>
          <h1 style={{ marginBottom: '0.5rem' }}>Something went wrong</h1>
          <p style={{ color: '#B0B0B0', marginBottom: '1.5rem', maxWidth: 360 }}>
            Please reload the page or call us at (951) 216-8534.
          </p>
          <button onClick={() => window.location.reload()} style={{
            background: '#39FF14', color: '#0D0D0D', border: 'none',
            borderRadius: '12px', padding: '12px 28px', fontWeight: 'bold',
            fontSize: '1rem', cursor: 'pointer',
          }}>
            Reload
          </button>
          {process.env.NODE_ENV !== 'production' && (
            <pre style={{ marginTop: '1rem', fontSize: '0.7rem', color: '#666', maxWidth: 500, textAlign: 'left', whiteSpace: 'pre-wrap' }}>
              {this.state.error}
            </pre>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
